import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer-container'>
      <section className='social-media'>
        <div className='social-media-wrap'>
          
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
              <img 
                src='./logo-transparent-bez-textu.png' 
                width="120" 
                alt="Finiš Logo" 
              />
            </Link>
          </div>

          <div className="website-rights-wrap">
            <small className='website-rights'>FINIŠ © {currentYear}</small>
            <small className='website-rights'>
              Tel.č: <a className='footer-contact-link' href="tel:0911151528">0911 151 528</a>
            </small>
            <small className='website-rights'>
              Email: <a className='footer-contact-link' href="mailto:finis.nitra@gmail.com">finis.nitra@gmail.com</a>
            </small>
          </div>

          <div className='social-icons'>
            <a
              className='social-icon-link facebook'
              href="https://www.facebook.com/Finis.Nitra"
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Facebook'
            >
              <i className='fab fa-facebook-f' />
            </a>
            <a
              className='social-icon-link instagram'
              href="https://www.instagram.com/nitrafinis"
              target="_blank" 
              rel='noopener noreferrer'
              aria-label='Instagram'
            >
              <i className='fab fa-instagram' />
            </a>
          </div>

        </div>
      </section>
    </footer>
  );
}

export default Footer;